
/**
 * @Description 商圈卡片
 * copy自 src/views/spotevaluation/pages/index/components/AreaDetailDrawer/components/FirstScreenRight/components/Surround/components/Community/index.tsx
 */
import { FC, useEffect, useState } from 'react';
import { Spin } from 'antd';
import { useMethods } from '@lhb/hook';
import { isArray } from '@lhb/func';
// import { NOT_MORE_DATA } from '../../../../ts-config';
import { getSpotEvaluationAroundPage, getSpotEvaluationAroundPageShare } from '@/common/api/spotevaluation';
import { SpotTypeEnum } from '@/views/spotevaluation/pages/index/ts-config';
import styles from './index.module.less';
import V2Pagination from '@/common/components/Data/V2Pagination';

// import VirtualList from 'rc-virtual-list';
import ListItem from './ListItem';
import Empty from '@/common/components/Empty';
import AreaDetailDrawer from '@/common/components/business/YouthMap/AreaDetailDrawer';

interface BusinessAreaProps {
  mainHeight: number;
  detail: any;
  filters: any;
  // curDetail: any;
  setCurDetail: Function;
  tenantId?: number;
  isShare?: boolean;
  drawerData?: any;
  shareParams?: any; // 分享时才有
}

const pageSize = 5;

const BusinessArea :FC<BusinessAreaProps> = ({
  tenantId,
  detail,
  filters,
  setCurDetail,
  // curDetail,
  mainHeight,
  drawerData = {},
  shareParams,
}) => {
  // const ContainerHeight = mainHeight;
  // const pageRef: any = useRef<number>(1); // 虚拟列表下拉筛选的分页page
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [list, setList] = useState<any[]>([]);
  const [detailDrawerData, setDetailDrawerData] = useState<any>({ // 开店区域详情抽屉
    open: false,
    id: '',
    // rankVal: null
  });
  const [totalNum, setTotalNum] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<any>(1); // 当前页数

  const methods = useMethods({
    // onScroll(e: any) {
    //   // 预留10px
    //   if (e.currentTarget.scrollHeight - e.currentTarget.scrollTop <= ContainerHeight + 10) {
    //     if (isLoading) return;
    //     if (pageRef.current !== NOT_MORE_DATA) {
    //       pageRef.current += 1;
    //       methods.loadCommonRimApiData(list);
    //     }
    //   }
    // },
    // 分页相关
    handlePageChange: (value: any) => {
      setIsLoading(true);
      setCurrentPage(value);
      // setPageSize(pageSize);
      methods.loadCommonRimApiData({ page: value });
    },
    loadCommonRimApiData: async (params: any) => {
      // const sizeVal = 200;
      try {
        let _params: any = {};
        const targetFeatch = tenantId ? getSpotEvaluationAroundPageShare : getSpotEvaluationAroundPage;
        const { type, modelConfigId, modelClusterId, radius } = drawerData;
        _params = {
          // page: pageRef.current,
          size: pageSize,
          poiSearchType: 1,
          lat: detail.lat,
          lng: detail.lng,
          aoiTypeCategoryId: 2,
          // secondAoiType: filters.secondAoiType,
          cityName: detail.cityName,
          type,
          modelConfigId,
          radius, // 先兼容接口在type2时也要求传radius的报错
          ...(!isNaN(Number(filters?.secondAoiType)) ? { secondAoiType: filters?.secondAoiType } : {}),
          ...params,
        };
        if (type === SpotTypeEnum.Mall) {
          _params.modelClusterId = modelClusterId;
          _params.radius = filters.distance;
        }
        if (type === SpotTypeEnum.Street) {
          _params.poiSearchType = detail?.poiSearchType;
          _params.radius = detail?.radius;
          _params.poiSearchMinute = detail?.poiSearchMinute;
          _params.poiSearchDistance = detail?.poiSearchDistance;
          _params.points = detail?.points;
        }
        if (tenantId) {
          _params.tenantId = tenantId;
        }
        const { objectList, totalNum: total } = await targetFeatch(_params, {
          needCancel: false
        });
        setTotalNum(total);
        const targetData = isArray(objectList) ? objectList : [];
        setList(targetData);
        setIsLoading(false);
        // }
      } catch (error) {
        setIsLoading(false);
      }
    },
  });

  useEffect(() => {
    // 初始化
    +(filters?.aoiTypeCategoryId) === 2 && methods.loadCommonRimApiData({
      page: 1,
    });
  }, [filters]);

  return (
    <div className={styles.businessAreaCon} style={{
      maxHeight: `${mainHeight}px`,
      // overflowY: 'auto'
    }}>
      <Spin
        spinning={isLoading}>
        {
          isLoading ? <></> : <>
            {
              Array.isArray(list) && list.length ? <>
                <div style={{
                  maxHeight: `${totalNum > pageSize ? mainHeight - 45 : mainHeight}px`,
                  overflowY: 'auto'
                }}>
                  {
                    list.map((item: any, index: number) => <ListItem
                      key={index}
                      item={item}
                      // curDetail={curDetail}
                      setCurDetail={setCurDetail}
                      shareParams={shareParams}
                      setDetailDrawerData={setDetailDrawerData}
                    />)
                  }
                </div>
                {totalNum > pageSize
                  ? <V2Pagination
                    simple={true}
                    disabled={isLoading}
                    current={currentPage}
                    total={totalNum}
                    onChange={methods.handlePageChange}
                    pageSize={pageSize}
                  /> : '' }
                <AreaDetailDrawer
                  modelConfigId={drawerData?.modelConfigId}
                  drawerData={detailDrawerData}
                  setDrawerData={setDetailDrawerData}
                  allowSurroundTitleJumpDetail={false}
                />
              </> : <Empty />
            }
          </>
        }
        {/* {Array.isArray(list) && list.length
          ? <>
            <VirtualList
              data={list}
              height={ContainerHeight}
              itemHeight={146}
              // coder: 陈宇，代码list是双层数组，没有 id这个key，数据构造应该有对象，加个随机id作为key
              itemKey='id'
              onScroll={methods.onScroll}
            >
              {(item: any, index:number) => (
              // <List.Item
              //   key={index}
              // >
                <ListItem
                  key={index}
                  item={item}
                  // curDetail={curDetail}
                  setCurDetail={setCurDetail}
                  shareParams={shareParams}
                  setDetailDrawerData={setDetailDrawerData}
                />
              // </List.Item>
              )}
            </VirtualList>
            <AreaDetailDrawer
              modelConfigId={drawerData?.modelConfigId}
              drawerData={detailDrawerData}
              setDrawerData={setDetailDrawerData}
              allowSurroundTitleJumpDetail={false}
            />
          </>
          : <Empty />
        } */}
      </Spin>
    </div>
  );
};


export default BusinessArea;
